import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { useFirmContext } from '../../providers/FirmProvider';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { Fragment } from 'react';

type NavBreadcrumbsProps = {
    hideWorkpaperName?: boolean;
    paths?: { label: string; to: string }[];
};

/**
 * Renders an interactive path informing the user which group, entity and workpaper they are currently in.
 *
 * e.g. ABC Group > ABC Entity > Annual Compliance
 *
 */
export default function NavBreadcrumbs({ hideWorkpaperName = false, paths = [] }: NavBreadcrumbsProps): JSX.Element {
    const { shortId } = useFirmContext();
    const { entity, groups, id, name } = useWorkpaperContext();

    return (
        <div className="text-gray-500 text-sm flex items-center gap-2">
            {groups && groups[0] && (
                <>
                    <Link to={`/${shortId}/groups/${groups[0].id}`} className="hover:underline">
                        {groups[0].name}
                    </Link>
                    <ChevronRightIcon className="h-5 w-5 text-gray-500" />
                </>
            )}

            <Link to={`/${shortId}/entities/${entity.id}`} className="hover:underline">
                {entity.name}
            </Link>

            {!hideWorkpaperName && (
                <>
                    <ChevronRightIcon className="h-5 w-5 text-gray-500" />
                    <Link to={`/${shortId}/workpapers/${id}`} className="hover:underline">
                        {name}
                    </Link>
                </>
            )}

            {paths.map((path, index) => (
                <Fragment key={index}>
                    <ChevronRightIcon className="h-5 w-5 text-gray-500" />
                    <Link to={path.to} className="hover:underline">
                        {path.label}
                    </Link>
                </Fragment>
            ))}
        </div>
    );
}
